<template>
    <div class="l-edit-dialog-box" style="padding-top:0">
      <el-form :model="form_data" label-width="120px" ref="form" label-position="top" v-loading="loading">
        <!-- <el-divider content-position="left">基础信息</el-divider> -->
        <el-row :gutter="50" style="margin-left:0;margin-right:0">
  
          <el-col :span="12">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="form_data.username" autocomplete="off" placeholder="请输入用户名" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
  
          <el-col :span="12">
            <el-form-item label="短码(不填自动生成)：" prop="search_no">
              <el-input v-model="form_data.search_no" autocomplete="off" placeholder="请输入短码："></el-input>
            </el-form-item>
          </el-col>
  
        </el-row>
      </el-form>
      <div class="l-dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "l-user-info-position",
    props: {
      id: {
        type: [Number, String],
        default: null,
      },
      visible: {
        type: Boolean,
      },
    },
    computed: {
      hasId() {
        return this.$props.id !== null;
      },
    },
    data() {
      return {
        loading: false, //页面是否加载中
        //表单数据
        form_data: {
          search_no: "",
          username: "",
          id: "",
        },
        //提交按钮是否显示加载中
        submitting: false,
      };
    },
    watch: {
      visible: {
        immediate: true,
        handler(val) {
          if (val) {
            this.getData();
          }
        },
      },
    },
  
    methods: {
      //点击取消通知父组件关闭对话框
      cancel() {
        this.$emit("update:visible", false);
      },
      //获取数据
      getData() {
        this.loading = true;
        if (this.hasId) {
          this.$_invoke("userPosition_getPositionData", {
            id: this.$props.id,
          })
            .then((ret) => {
              console.log(ret)
              this.form_data.role_id = ret.admin_info.role_id;
              this.form_data.username = ret.admin_info.username;
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
  
      //提交数据
      handleSubmit() {
        if (this.loading) return;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitting = true;
            if (this.hasId) {
              //修改
              this.form_data.id = this.$props.id;
              this.$_invoke("userPosition_getSearch", this.form_data)
                .then(() => {
                  this.$_msg.success("获取成功");
                  this.$emit("on-success");
                })
                .finally(() => {
                  this.submitting = false;
                });
            }
          }
        });
      },
    },
  };
  </script>